export default __webpack_public_path__ + "static/media/List-documentation.c3f3fb68.md";